import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'
import {
  BooleanParam,
  NumberParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import CustomRange from '../CustomRange'

import s from './Volume.module.css'

const rangeOptions = [
  { lowerLimit: 100001, upperLimit: null },
  { lowerLimit: 10001, upperLimit: 100000 },
  { lowerLimit: 1001, upperLimit: 10000 },
  { lowerLimit: 101, upperLimit: 1000 },
  { lowerLimit: 11, upperLimit: 100 },
  { lowerLimit: 1, upperLimit: 10 },
]

type Props = {
  onChange: () => void
}

export const Volume: FC<Props> = ({ onChange }) => {
  const history = useHistory()
  const [queryParams, setQueryParams] = useQueryParams({
    'volume:lte': withDefault(NumberParam, null),
    'volume:gte': withDefault(NumberParam, null),
    'sug_volume:lte': withDefault(NumberParam, null),
    'sug_volume:gte': withDefault(NumberParam, null),
    page: withDefault(NumberParam, 1),
    content_ideas: withDefault(BooleanParam, false),
  })

  const isSuggestionsFilter =
    history.location.pathname === '/content-ideas' || queryParams.content_ideas

  const handleSubmit = (
    initialValue: number | null,
    finalValue: number | null
  ) => {
    if (isSuggestionsFilter) {
      setQueryParams({
        'sug_volume:lte': initialValue,
        'sug_volume:gte': finalValue,
        page: 1,
      })
    } else {
      setQueryParams({
        'volume:lte': initialValue,
        'volume:gte': finalValue,
        page: 1,
      })
    }
    onChange()
  }

  return (
    <div className={s.menu}>
      <div>
        {rangeOptions.map(range => {
          return (
            <button
              className={clsx(s.range, {
                [s.active]: isSuggestionsFilter
                  ? range.lowerLimit === queryParams['sug_volume:gte']
                  : range.lowerLimit === queryParams['volume:gte'],
              })}
              key={range.upperLimit}
              onClick={() => handleSubmit(range.upperLimit, range.lowerLimit)}
            >
              {range.lowerLimit.toLocaleString()}
              {range.upperLimit ? (
                <> - {range.upperLimit.toLocaleString()}</>
              ) : (
                '+'
              )}
            </button>
          )
        })}
      </div>
      <CustomRange onSubmit={handleSubmit} />
    </div>
  )
}
